export enum AutomationStatus {
  draft = 'draft',
  published = 'published',
  unpublished = 'unpublished',
  archived = 'archived',
}

export enum AutomationAppearanceType {
  hidden = 'hidden',
  visible = 'visible',
}

export enum AutomationNodeTypeEnum {
  trigger = 'trigger',
  action = 'action',
  condition = 'condition',
}

export enum AutomationNodeStatusEnum {
  archived = 'archived',
  active = 'active',
}

export enum AutomationEdgeStatusEnum {
  archived = 'archived',
  active = 'active',
}
